const subheadingData = {
  1: [
    {
      title: 'About Me',
      content: (
        <>
          <p>
            Full-Stack Web Developer
            with a keen interest in
            product design and a
            language-agnostic approach
            to creative troubleshooting.
            Strong technical skills in building
            25+ projects in a remote setting,
            as well as excellent communication and problem-solving skills that
            enable me to collaborate
            effectively with clients
            and colleagues. Experienced
            in web and app development,
            focusing on Ruby on Rails,
            JavaScript/React, HTML, and CSS.
          </p>
        </>
      ),
    },
  ],
  2: [
    {
      title: '2016 BSc Degree in Structural Engineering',
      content: (
        <>
          <p>
            Spent 4000+ hours mastering how to design different kinds of structures.
          </p>
        </>
      ),
    },
    {
      title: '2023 Remote Full Stack Web Development Program, Full-Time',
      content: (
        <>
          <p>
            Spend 1300+ hours mastering
            algorithms, data structures,
            and full-stack development
            while simultaneously developing
            projects with Ruby, Rails, JavaScript, React, and Redux.
            Developed skills in
            remote pair programming
            using GitHub, industry-standard
            git-flow, and daily
            standups to communicate and collaborate with international remote developers.

          </p>
        </>
      ),
    },
  ],
  3: [
    {
      title: '2023 Mentor (Volunteer)',
      content: (
        <>
          <p>
            Mentored junior web developers, providing technical support through code reviews.
            Helped  20+ students
            throughout 2 modules,
            boosting my skills in how to stay connected using Zoom, and Slack.
          </p>
        </>
      ),
    },
    {
      title: '2017 Resident Engineer',
      content: (
        <>
          <p>
            Gained great experience
            in leading a team of more than 7 people, designing a concrete structure.
            Designed 10+ construction
            projects alongside a
            variety of engineering teams mastering my problem-solving and communication skills.
          </p>
        </>
      ),
    },
  ],
};

export default subheadingData;
